import log from 'salvo-lite/log'
class SortBy {
    constructor (theme, elem) {
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('change', (e) => {
            const urlSearchParams = new URLSearchParams(window.location.search)
            urlSearchParams.set(this._elem.name, this._elem.value)
            window.location = `?${urlSearchParams}`
        })
    }
}

export default SortBy



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SortBy.js